import React, { useState } from "react";
import { Loader2, AlertTriangle } from "lucide-react";
import { api } from "@/lib/api";
import SparkPostPanel from "@/components/admin/SparkPostPanel";
import InfobipPanel from "@/components/admin/InfobipPanel";
import GoogleWorkspacePanel from "@/components/admin/GoogleWorkspacePanel";

function ProviderSwitch({ site, reload }) {
  const [saving, setSaving] = useState(false);
  const override = site.email_provider || "";
  const folderDefault = site.email_provider_folder || "sparkpost";
  const effective = site.email_provider_effective || "sparkpost";

  async function change(value) {
    setSaving(true);
    try { await api.patch(`/sites/${site.id}`, { email_provider: value || null }); await reload(); }
    finally { setSaving(false); }
  }

  return (
    <div className="flex items-center gap-2" data-testid="email-provider-switch">
      <span className="text-[11px] text-zinc-500 uppercase tracking-wider">Provider</span>
      <select data-testid="email-provider-select" value={override} disabled={saving} onChange={(e) => change(e.target.value)} className="bg-zinc-950 border border-zinc-800 rounded-sm px-2 py-1.5 text-xs outline-none disabled:opacity-50">
        <option value="">Folder default ({folderDefault})</option>
        <option value="sparkpost">SparkPost</option>
        <option value="infobip">Infobip</option>
      </select>
      <span className="text-[11px] text-zinc-600 mono">→ {effective}</span>
      {saving && <Loader2 size={12} className="animate-spin text-zinc-500" />}
    </div>
  );
}

/** Outbound transactional email: provider switch + the active provider's panel. */
export function TransactionalEmail({ site, reload }) {
  const infobip = (site.email_provider_effective || "sparkpost") === "infobip";
  return (
    <div className="pt-6 mt-2 border-t border-zinc-800">
      <div className="flex items-center justify-between mb-3 gap-3 flex-wrap">
        <div className="label-tiny">Outbound transactional email</div>
        <ProviderSwitch site={site} reload={reload} />
      </div>
      {infobip ? <InfobipPanel site={site} reload={reload} /> : <SparkPostPanel site={site} reload={reload} />}
    </div>
  );
}

export function WorkspaceSection({ site, reload }) {
  return (
    <div className="pt-6 mt-2 border-t border-zinc-800">
      <div className="label-tiny mb-3">Mailboxes · Google Workspace</div>
      <GoogleWorkspacePanel site={site} reload={reload} />
    </div>
  );
}

export function NoZoneNotice() {
  return (
    <div className="border border-amber-500/30 bg-amber-500/5 text-amber-300 rounded-sm p-5 text-sm">
      <div className="flex items-start gap-3">
        <AlertTriangle size={18} className="mt-0.5 shrink-0" />
        <div>
          <div className="font-semibold mb-1">No Cloudflare zone yet</div>
          <div className="text-xs leading-relaxed opacity-90">Email routing lives on the Cloudflare zone. Purchase or link a domain on the <b>Domain</b> tab first, then come back here.</div>
        </div>
      </div>
    </div>
  );
}
